import React from 'react';

//Estilos
import '../../styles/advertencia.css';

//Imagenes
import logo from '../../imgs/otros/juego rio-15.png';
import monitor from '../../imgs/otros/pantalla-del-monitor.png';
import celular from '../../imgs/otros/telefono-inteligente.png';
import girarMovil from '../../imgs/otros/telefono-movil.png';
import zoomMovil from '../../imgs/otros/disminuir-el-zoom.png';
import instruccionesImagen from '../../imgs/otros/juego rio-14.png';





export default function Advertencia(props) {
    return (
        <div className='advertencia__div--container'>
            <div onClick={() => props.setPantallaAdvertencia(false)} className='advertencia__div--cerrar'></div>
            <img className='advertencia__img advetencia__img--logo' src={logo} alt='logo.png'/>
            <h2 className='advertencia__h2'>
                Advertencia!!!
            </h2>
            <p className='advertencia__p advertencia__p--parrafo1'>
                Para una mejor experiencia de juego se recomienda jugar en pantallas grandes tipo PC de escritorio.
            </p>
            <img className='advertencia__img advetencia__img--monitor'  src={monitor} alt='monitor.png'/>
            <p className='advertencia__p advertencia__p--parrafo2'>
                Si te encuentras desde dispositivo móvil o Tablet se recomienda girar la pantalla para una mejor experiencia de juego.
            </p>
            <div className='advertencia__div--container-img-celular'>
                <img className='advertencia__img advetencia__img--celular' src={celular} alt='celular.png'/>
                <img className='advertencia__img advetencia__img--girar-movil' src={girarMovil} alt='girarMovil.png'/>
            </div>
            <p className='advertencia__p advertencia__p--parrafo3'>
                Puedes hacer zoom para mejorar la interacción con el juego desde dispositivo móvil.
            </p>
            <img className='advertencia__img advetencia__img--zoom-movil' src={zoomMovil} alt='zoom-movil.png'/>
            <p className='advertencia__p advertencia__p--parrafo5'>
                Encontraras los iconos que se representan en la imagen a continuación da click sobre ellos para tener una guía sobre el funcionamiento del apartado en el que te encuentres.
            </p>
            <img className='advertencia__img advetencia__img--zoom-movil' src={instruccionesImagen} alt='zoom-movil.png'/>
            <p className='advertencia__p advertencia__p--parrafo4'>
                Disfruta del juego
            </p>
        </div>
    )
}
